import { flashNews } from "@/mocks/home";

export default function FlashNews() {
  const tickerItems = [...flashNews, ...flashNews];

  return (
    <section id="flash" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-page px-4 py-8 md:px-6 md:py-12">
        <div className="mb-5 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950 md:text-3xl">
              <i className="ri-flashlight-line text-accent-600" />
              短讯快报
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              一句话一条，短平快跟进事件进展，热度越高刷新越勤。
            </p>
          </div>
          <span className="flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-600">
            <i className="ri-timer-line text-secondary-600" />
            今日已更新 24 条 · 每 5 分钟滚动
          </span>
        </div>

        <div className="marquee-wrap mb-5 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-2.5">
          <div className="flex w-max animate-marquee items-center gap-10 px-4">
            {tickerItems.map((item, index) => (
              <span
                key={`${item.time}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700"
              >
                <span className="font-label text-xs text-primary-600">{item.time}</span>
                <span className="rounded-full border border-background-300 bg-background-100 px-2 py-0.5 text-[11px] text-secondary-900">
                  {item.tag}
                </span>
                {item.text}
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-2 lg:grid-cols-4">
          {flashNews.map((item) => (
            <article
              key={`${item.time}-${item.text}`}
              className="group cursor-pointer bg-background-50 p-4 transition-colors hover:bg-accent-50"
            >
              <div className="flex items-center gap-2">
                <span className="font-heading text-lg text-foreground-950">{item.time}</span>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                  {item.tag}
                </span>
              </div>
              <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-400 transition-colors group-hover:text-primary-600">
                查看进展
                <i className="ri-arrow-right-line" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}